var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg007Responsive1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "937pt",
    viewBox: "0 -62 937.5 937",
    width: "937pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.25 62.75 C 31.25 45.488281 45.238281 31.5 62.5 31.5 L 812.5 31.5 C 829.761719 31.5 843.75 45.488281 843.75 62.75 L 843.75 281.5 L 875 281.5 L 875 62.75 C 875 28.234375 847.015625 0.25 812.5 0.25 L 62.5 0.25 C 27.984375 0.25 0 28.234375 0 62.75 L 0 594 C 0 628.515625 27.984375 656.5 62.5 656.5 L 338.375 656.5 L 300.875 781.5 L 265.625 781.5 L 265.625 812.75 L 609.375 812.75 L 609.375 781.5 L 574.125 781.5 L 536.625 656.5 L 609.375 656.5 L 609.375 625.25 L 62.5 625.25 C 45.238281 625.25 31.25 611.261719 31.25 594 L 31.25 562.75 L 609.375 562.75 L 609.375 531.5 L 31.25 531.5 Z M 371 656.5 L 504 656.5 L 541.5 781.5 L 333.5 781.5 Z M 371 656.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 812.5 281.5 L 812.5 78.375 C 812.5 69.742188 805.507812 62.75 796.875 62.75 L 78.125 62.75 C 69.492188 62.75 62.5 69.742188 62.5 78.375 L 62.5 500.25 L 93.75 500.25 L 93.75 219 L 781.25 219 L 781.25 281.5 Z M 93.75 187.75 L 93.75 94 L 781.25 94 L 781.25 187.75 Z M 93.75 187.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 140.625 125.25 L 234.375 125.25 L 234.375 156.5 L 140.625 156.5 Z M 140.625 125.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265.625 125.25 L 359.375 125.25 L 359.375 156.5 L 265.625 156.5 Z M 265.625 125.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 390.625 125.25 L 484.375 125.25 L 484.375 156.5 L 390.625 156.5 Z M 390.625 125.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 515.625 125.25 L 609.375 125.25 L 609.375 156.5 L 515.625 156.5 Z M 515.625 125.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.5 265.875 C 312.5 257.242188 305.507812 250.25 296.875 250.25 L 140.625 250.25 C 131.992188 250.25 125 257.242188 125 265.875 L 125 390.875 C 125 399.507812 131.992188 406.5 140.625 406.5 L 296.875 406.5 C 305.507812 406.5 312.5 399.507812 312.5 390.875 Z M 281.25 375.25 L 156.25 375.25 L 156.25 281.5 L 281.25 281.5 Z M 281.25 375.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 531.25 265.875 C 531.25 257.242188 524.257812 250.25 515.625 250.25 L 359.375 250.25 C 350.742188 250.25 343.75 257.242188 343.75 265.875 L 343.75 390.875 C 343.75 399.507812 350.742188 406.5 359.375 406.5 L 515.625 406.5 C 524.257812 406.5 531.25 399.507812 531.25 390.875 Z M 500 375.25 L 375 375.25 L 375 281.5 L 500 281.5 Z M 500 375.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 593.75 281.5 L 750 281.5 L 750 265.875 C 750 257.242188 743.007812 250.25 734.375 250.25 L 578.125 250.25 C 569.492188 250.25 562.5 257.242188 562.5 265.875 L 562.5 390.875 C 562.5 399.507812 569.492188 406.5 578.125 406.5 L 609.375 406.5 L 609.375 375.25 L 593.75 375.25 Z M 593.75 281.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.5 500.25 L 312.5 453.375 C 312.5 444.742188 305.507812 437.75 296.875 437.75 L 140.625 437.75 C 131.992188 437.75 125 444.742188 125 453.375 L 125 500.25 L 156.25 500.25 L 156.25 469 L 281.25 469 L 281.25 500.25 Z M 312.5 500.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 531.25 500.25 L 531.25 453.375 C 531.25 444.742188 524.257812 437.75 515.625 437.75 L 359.375 437.75 C 350.742188 437.75 343.75 444.742188 343.75 453.375 L 343.75 500.25 L 375 500.25 L 375 469 L 500 469 L 500 500.25 Z M 531.25 500.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 562.5 453.375 L 562.5 500.25 L 593.75 500.25 L 593.75 469 L 609.375 469 L 609.375 437.75 L 578.125 437.75 C 569.492188 437.75 562.5 444.742188 562.5 453.375 Z M 562.5 453.375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 875 312.75 L 703.125 312.75 C 668.609375 312.75 640.625 340.734375 640.625 375.25 L 640.625 750.25 C 640.625 784.765625 668.609375 812.75 703.125 812.75 L 875 812.75 C 909.515625 812.75 937.5 784.765625 937.5 750.25 L 937.5 375.25 C 937.5 340.734375 909.515625 312.75 875 312.75 Z M 906.25 750.25 C 906.25 767.511719 892.261719 781.5 875 781.5 L 703.125 781.5 C 685.863281 781.5 671.875 767.511719 671.875 750.25 L 671.875 734.625 L 906.25 734.625 Z M 906.25 703.375 L 671.875 703.375 L 671.875 375.25 C 671.875 357.988281 685.863281 344 703.125 344 L 875 344 C 892.261719 344 906.25 357.988281 906.25 375.25 Z M 906.25 703.375 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 859.375 437.75 L 718.75 437.75 C 710.117188 437.75 703.125 444.742188 703.125 453.375 L 703.125 578.375 C 703.125 587.007812 710.117188 594 718.75 594 L 859.375 594 C 868.007812 594 875 587.007812 875 578.375 L 875 453.375 C 875 444.742188 868.007812 437.75 859.375 437.75 Z M 843.75 562.75 L 734.375 562.75 L 734.375 469 L 843.75 469 Z M 843.75 562.75 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 859.375 625.25 L 718.75 625.25 C 710.117188 625.25 703.125 632.242188 703.125 640.875 L 703.125 672.125 L 734.375 672.125 L 734.375 656.5 L 843.75 656.5 L 843.75 672.125 L 875 672.125 L 875 640.875 C 875 632.242188 868.007812 625.25 859.375 625.25 Z M 859.375 625.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 703.125 375.25 L 875 375.25 L 875 406.5 L 703.125 406.5 Z M 703.125 375.25 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg007Responsive1);
export default __webpack_public_path__ + "static/media/007-responsive-1.f71d7b608efe1f0f2a770fd4f8e673df.svg";
export { ForwardRef as ReactComponent };